import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import { withLogisticReports } from "../../../shared/containers/containerLogisticReport";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { NavLink } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import getDates from "../../../shared/services/date.service";
import Scrollbars from "react-custom-scrollbars-2";
import { controlPointStatus } from "./LogisticReportsControlPointStatus";
import LogisticReportsTaskTripMap from "./LogisticReportsTaskTripMap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { withMapPositions } from "../../../shared/containers/containerMapPositions";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";
import { withAuth } from "../../../shared/containers/containerAuth";

class LogisticReportsTaskTrip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isViewMap: false,
      controlPoints: [],
      controlPointView: null,
    };
  }

  onSetViewMapState(isViewMap) {
    this.setState({ isViewMap, controlPointView: null });
  }

  componentDidMount() {
    const { taskTrip, onGetTaskTripReport, onSetViewPanel } = this.props;

    if (taskTrip === null) {
      const taskTripId = window.location.pathname.replace("/logistic/reports", "").replace("/", "");

      if (taskTripId !== "" && taskTripId !== "/") {
        onGetTaskTripReport({ id: taskTripId });
      } else {
        onSetViewPanel("controPointReports");
      }
    }
  }

  componentDidUpdate(preProps) {
    const { onSetViewPanel, taskTrip } = this.props;
    const { controlPoints } = this.state;

    const taskTripId = window.location.pathname.replace("/logistic/reports", "").replace("/", "");
    if (taskTripId === "" || taskTripId === "/") {
      onSetViewPanel("controPointReports");
    }

    if (taskTrip !== null && controlPoints.length === 0) {
      let _controlPoints = [];

      taskTrip.units.forEach((unit) => {
        unit.routes.forEach((route) => {
          _controlPoints = _controlPoints.concat(
            route.controlPoints.map((cp) => {
              cp.unit = unit;

              return cp;
            })
          );
        });
      });

      if (_controlPoints.length > 0) {
        this.setState({ controlPoints: _controlPoints });
      }
    }
  }

  componentWillUnmount() {
    const { onClearTaskTripReport } = this.props;
    onClearTaskTripReport();
  }

  onDownloadClick() {
    const { onLogisticTaskTrpReportDownload, taskTrip } = this.props;
    const title = `${taskTrip.title} ${getDates.getDateFormat8(taskTrip.timeStart)} ${getDates.getDateFormat8(taskTrip.timeEnd)}`;

    onLogisticTaskTrpReportDownload({ id: taskTrip.id }, title);
  }

  onClickRowHandler(controlPoint) {
    this.setState({ controlPointView: { latitude: controlPoint.latitude, longitude: controlPoint.longitude } });
  }

  render() {
    const { taskTrip, onSetViewPanel, getTaskTripReportDataState, data } = this.props;
    const { isViewMap, controlPoints, controlPointView } = this.state;

    const height = (window.innerHeight > 800 ? 600 : 400) / (isViewMap ? 2 : 1);

    if (getTaskTripReportDataState === states.REQUEST) {
      return (
        <div style={{ display: "flex", justifyContent: "center", height: `${height}px` }}>
          <Preloader />
        </div>
      );
    }

    if (taskTrip === null) return null;

    let count = 0;

    const downloadPermission = data.permissions.includes(53003);

    return (
      <div key={taskTrip.id}>
        <div className={styles.taskTripTitleContainer}>
          <div>Рейс: "{taskTrip.title}"</div>

          <div className={styles.closeContainer}>
            <div style={{ paddingRight: "20px" }}>
              {downloadPermission ? <ButtonIconWrapper type={"primary"} icon="save" handleClick={this.onDownloadClick.bind(this)} /> : null}
            </div>

            <div
              className={styles.coloseButton}
              onClick={(e) => {
                e.stopPropagation();
                onSetViewPanel("controPointReports");
              }}
            >
              <TooltipWrapper title={"Закрыть"} position="left">
                <NavLink to={`/logistic/reports`}>
                  <HighlightOffIcon style={{ color: "red" }} />
                </NavLink>
              </TooltipWrapper>
            </div>
          </div>
        </div>
        <div className={styles.taskTripTitleContainer}>
          <div>
            С {getDates.getDateFormat8(taskTrip.timeStart)} по {getDates.getDateFormat8(taskTrip.timeEnd)}
          </div>
        </div>

        {taskTrip.description !== null && taskTrip.description !== "" ? (
          <div>
            <b>Описание: </b> <span> {taskTrip.description}</span>
          </div>
        ) : null}

        <div>
          <b>Состояние: </b> <span> {taskTrip.isCompleted ? "Завершен" : "В процессе"}</span>
        </div>

        <div>
          <b>Исполнение: </b>{" "}
          <span style={{ color: taskTrip.isViolation ? "red" : "black" }}>{taskTrip.isViolation ? "С нарушениями" : "Без нарушений"}</span>
        </div>

        {isViewMap ? (
          <LogisticReportsTaskTripMap
            onSetViewMapState={this.onSetViewMapState.bind(this)}
            height={height + 150}
            controlPoints={controlPoints}
            isTaskTripCompleted={taskTrip.isCompleted}
            tripGeometries={taskTrip.geojsonData === undefined ? null : taskTrip.geojsonData.tripGeometries}
            taskTrip={taskTrip}
            controlPointView={controlPointView}
          />
        ) : (
          <div className={styles.viewMapOpenContainer}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                this.onSetViewMapState(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <TooltipWrapper title={`Просмотреть рейс на карте`} position="top">
                <VisibilityIcon fontSize="small" />
              </TooltipWrapper>
            </div>
          </div>
        )}

        <div className={styles.taskTripCPItemReportHeader}>
          <div className={styles.taskTripRouteControlPointsContainer} style={{ display: "flex", width: "100%" }}>
            <div style={{ width: `25%` }}>
              <b>Контрольная точка</b>
            </div>

            <div style={{ width: `35%` }}>
              <b>Адрес</b>
            </div>

            <div style={{ width: `10%` }}>
              <b>Начало изменено</b>
            </div>

            <div style={{ width: `10%` }}>
              <b>Окончание изменено</b>
            </div>

            <div style={{ width: `10%` }}>
              <b>Посещено</b>
            </div>

            <div style={{ width: `10%` }}>
              <b>Статус</b>
            </div>
          </div>
        </div>

        <div className={styles.taskTripRouteListReport}>
          <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
            {taskTrip.units.map((unit) => {
              return (
                <div key={unit.id}>
                  {unit.routes.map((route, index) => {
                    return (
                      <div key={index}>
                        <div>
                          <div>
                            <b>Транспортное средство: </b> <span> {unit.title}</span>
                          </div>

                          <div>
                            <b>Регистрационный номер: </b> <span> {unit.registerNumber}</span>
                          </div>
                        </div>

                        <div key={route.id} className={styles.taskTripRouteItemReport}>
                          <div>
                            <span>{route.title}</span>
                          </div>

                          {route.isChangeAlarm
                            ? `Расписание изменено с ${getDates.getDateFormat8(route.timeStart)} по ${getDates.getDateFormat8(
                                route.timeEnd
                              )}`
                            : ""}
                        </div>
                        <div className={styles.taskTripRouteControlPointsContainer}>
                          {route.controlPoints.map((controlPoint) => {
                            const isViolation = taskTrip.isCompleted && controlPoint.status !== 1;
                            const color = !taskTrip.isCompleted && controlPoint.status === 0 ? "#ff8315" : "black";
                            count++;

                            return (
                              <div
                                key={controlPoint.id}
                                className={styles.taskTripCPItemReport}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.onClickRowHandler(controlPoint);
                                }}
                              >
                                <div style={{ width: `25%` }}>
                                  <span>
                                    <b>{count}.</b> {controlPoint.title}
                                  </span>
                                </div>

                                <div style={{ width: `35%` }}>
                                  <span> {controlPoint.address}</span>
                                </div>

                                <div style={{ width: `10%` }}>
                                  <span> {controlPoint.isChangeAlarm ? getDates.getDateFormat8(controlPoint.timeStart) : ""} </span>
                                </div>

                                <div style={{ width: `10%` }}>
                                  <span> {controlPoint.isChangeAlarm ? getDates.getDateFormat8(controlPoint.timeEnd) : ""} </span>
                                </div>

                                <div style={{ width: `10%` }}>
                                  <span>
                                    {!controlPoint.timeEvent.includes("0001-01-01") ? getDates.getDateFormat9(controlPoint.timeEvent) : ""}
                                  </span>
                                </div>

                                <div style={{ width: `10%` }}>
                                  <span style={{ color: isViolation ? "red" : color }}> {controlPointStatus[controlPoint.status]}</span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default withAuth(withMapPositions(withLogisticReports(React.memo(LogisticReportsTaskTrip))));
